<template lang="pug">
    Page.advantages-edit
        .advantages-edit__top(
            slot="header"
        )
            h1.advantages-edit__title
                | Создание преимуществ объекта

            SvMenu(
                @copy="copy"
                @remove="remove"
            )

        SvTabs.advantages-edit__table(
            :tabs="['Основное']"
            :current="0"
        )
            .advantages-edit__actions
                SvButton.advantages-edit__action(
                    view="secondary"
                    text="Отмена"
                    :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                    @click="resetForm"
                )

                SvButton.advantages-edit__action(
                    view="secondary"
                    text="Применить"
                    :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                    @click="save(false)"
                )

                SvButton.advantages-edit__action(
                    view="primary"
                    text="Сохранить"
                    :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                    @click="save(true)"
                )

        .advantages-edit__form
            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Активность

                .advantages-edit__form-elements--small.radio
                    SvRadio.advantages-edit__form-radio(
                        v-model="is_active"
                        :value="true"
                        label="Да"
                    )

                    SvRadio.advantages-edit__form-radio(
                        v-model="is_active"
                        :value="false"
                        label="Нет"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Сортировка

                .advantages-edit__form-elements--small
                    SvInput(
                        v-model="sort"
                        color="graylight"
                        placeholder="Например: 500"
                        :withIcon="false"
                        :error="errors.sort"
                        @focus="resetError('sort')"
                        @blur="(value) => validateField(value, 'sort')"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Заголовок

                .advantages-edit__form-elements--small
                    SvInput(
                        v-model="title"
                        placeholder="Например: 5 минут"
                        color="graylight"
                        :withIcon="false"
                        :error="errors.title"
                        @focus="resetError('title')"
                        @blur="(value) => validateField(value, 'title')"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Подзаголовок

                .advantages-edit__form-elements--medium
                    SvInput(
                        v-model="subtitle"
                        placeholder="Например: до пляжа"
                        color="graylight"
                        :withIcon="false"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Заголовок на сайте

                .advantages-edit__form-elements--medium
                    SvInput(
                        v-model="filter_title"
                        color="graylight"
                        :withIcon="false"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | Описание

                .advantages-edit__form-elements--medium
                    SvInput(
                        v-model="description"
                        placeholder="Например: Живите в доме на берегу реки"
                        color="graylight"
                        :withIcon="false"
                    )

            .advantages-edit__form-item
                span.advantages-edit__form-title
                    | В фильтре на сайте

                .advantages-edit__form-elements--small.radio
                    SvRadio.advantages-edit__form-radio(
                        v-model="use_in_filter"
                        :value="true"
                        label="Да"
                    )

                    SvRadio.advantages-edit__form-radio(
                        v-model="use_in_filter"
                        :value="false"
                        label="Нет"
                    )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {validData} from '@/config/advantagesObject.js';
import {validate} from '@/helpers/validator.js';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';


export default {
    name: 'AdvantagesObjectEdit',

    data() {
        return {
            errors: {
                sort: '',
                title: '',
            }
        };
    },

    beforeMount() {
        this.$store.dispatch('advantageObject/getById', this.$route.params.id);
    },

    beforeRouteUpdate(to, from, next) {
        if (to.params.id !== 'new') {
            this.$store.dispatch('advantageObject/getById', to.params.id);
        }
        next();
    },

    computed: {
        ...mapGetters({
            current: 'advantageObject/getCurrent',
        }),

        is_active: {
            get() {
                return this.current.is_active;
            },
            set(is_active) {
                this.setValue({is_active});
            },
        },

        sort: {
            get() {
                return this.current.sort;
            },
            set(sort) {
                this.setValue({sort});
            },
        },

        title: {
            get() {
                return this.current.title;
            },
            set(title) {
                this.setValue({title});
            },
        },

        subtitle: {
            get() {
                return this.current.subtitle;
            },
            set(subtitle) {
                this.setValue({subtitle});
            },
        },

        description: {
            get() {
                return this.current.description;
            },
            set(description) {
                this.setValue({description});
            },
        },

        isHaveErrors() {
            return Object.keys(this.errors).some(key => this.errors[key]);
        },

        use_in_filter: {
            get() {
                return this.current.use_in_filter;
            },
            set(use_in_filter) {
                this.setValue({use_in_filter});
            },
        },

        filter_title: {
            get() {
                return this.current.filter_title;
            },
            set(filter_title) {
                this.setValue({filter_title});
            },
        },
    },

    methods: {
        ...mapMutations({
            setValue: 'advantageObject/setValue',
        }),

        resetError(field) {
            this.errors = {
                ...this.errors,
                [field]: ''
            };
        },

        validateField(value, key) {
            const response = validate(value, validData[key]);
            if (response !== 'OK') {
                this.setError({[key]: response});
            }
        },

        resetForm() {
            this.$store.commit('advantageObject/clearCurrent');
            this.$router.push({name: 'advantage-objects'});
        },

        setError(error) {
            this.errors = {
                ...this.errors,
                ...error
            }
        },

        copy() {
            this.$store.commit('advantageObject/setCurrent', this.$route.params.id);
            this.setValue({id: null});
            this.$router.push({name: 'advantage-object-edit', params: {id: 'new'}});
        },

        async remove() {
            await this.$store.dispatch('advantageObject/remove', this.$route.params.id);
            this.$router.push({name: 'advantage-objects'});
        },

        validateAll(fields) {
            return Object.keys(fields).reduce((res, key) => {
                const response = validate(fields[key], validData[key]);
                if (response !== 'OK') {
                    this.setError({[key]: response});
                    return false;
                }
                return res;
            }, true);
        },

        async save(isRedirect = false) {
            if (!this.validateAll({sort: this.sort, title: this.title})) return;
            const id = await this.$store.dispatch('advantageObject/save');
            if (!isRedirect) {
                this.$router.push({
                    name: 'advantage-object-edit',
                    params: {
                        id,
                    },
                }).catch(err => {
                });
            } else {
                this.resetForm();
            }
        },
    },

    components: {
        Page,
        SvInput,
        SvButton,
        SvTabs,
        SvMenu,
        SvRadio,
        SvUpload,
    },
};
</script>

<style lang="scss" scoped>
.advantages-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.advantages-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.advantages-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.advantages-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.advantages-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.advantages-edit__form {
    padding: 50px 0;
}

.advantages-edit__form-radio {
    margin-right: 21px;
}

.advantages-edit__form-elements--medium {
    width: 495px;
}

.advantages-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.advantages-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
